module.exports = __webpack_public_path__ + "static/media/close-black-symbol.bbb830c8.svg";